import {getValueByDevice, useDevice} from 'platform/foundation';

/**
 * Whether the viewport leaves no choice but the card view. The compact sourcing table needs
 * ~872px of column width (~852px for auctions), which is more than a tablet viewport offers, so
 * at or below the tablet breakpoint the card view is enforced.
 *
 * This answers only "is the card view enforced", not "is the card view showing" - above the
 * breakpoint the user can still pick it themselves, and their stored preference is left alone.
 */
export function useIsSourcingCardViewEnforced() {
  const device = useDevice();

  return getValueByDevice(device, true, true, false, false);
}
